import styled from "styled-components";
import login_bg from "./../../assets/images/img_bg.jpg";

const Styles = styled.div`
  /* 로그인, 패스워드 찾기 공통 */
  background: url(${login_bg}) no-repeat left top;
  background-size: cover;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5e6675;

  & .login-box {
    width: 480px;
    padding: 70px 60px;
    background: #f7f8fa;
    border: 1px solid #d8dbe3;
    & h1 {
      font-weight: 800;
      font-size: 24px;
      line-height: 34px;
      margin-bottom: 53px;
      text-align: center;
      letter-spacing: -1px;
    }

    & .btn-large {
      width: 100%;
      height: 51px;
      margin-top: 45px;
      font-size: 16px;
      transition: none;
    }
    & a {
      color: #5e6675;
    }
  } /* 로그인, 패스워드 찾기 공통 */

  /* 로그인 */
  .frm-login {
    & .ant-input {
      height: 50px;
      line-height: 50px;
    }
    & .ant-input-affix-wrapper {
      padding-top: 0;
      padding-bottom: 0;
    }

    & .ant-form-item {
      margin-bottom: 8px;
    }
  }

  /* 패스워드 찾기 */
  & .ant-collapse {
    border: 0;
    & .ant-collapse-item {
      border: 1px solid #d8dbe3;
      margin-bottom: 8px;
    }
    & .ant-collapse-item-disabled > .ant-collapse-header {
      color: #5e6675;
      cursor: default;
    }
    & .ant-collapse-header {
      font-size: 15px;
      display: flex;
      justify-content: space-between;
      & > div {
        order: 1;
        margin-right: 0;
        transform: rotate(-90deg);
        transition: 0.3s;
        & .anticon {
          margin: 0;
        }
        & svg {
          transform: none !important;
        }
      }
    }
    & .ant-collapse-item-active .ant-collapse-header > div {
      transform: rotate(90deg);
    }
    & .ant-collapse-content {
      background: #e9ecf1;
      /* padding: 14px;
            & > .ant-collapse-content-box {
                padding: 0;
            } */
    }
    & .ant-form-item {
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  /* 로그인, 패스워드 찾기 공통  - 반응형(모바일)*/
  @media all and (max-width: 767px) {
    & .login-box {
      width: 100%;
      min-height: 100vh;
      padding: 70px 35px;
      border: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    @media all and (orientation: landscape) {
      & .login-box {
        padding: 35px;
        & h1 {
          margin-bottom: 20px;
        }
        & .btn-large {
          margin: 0 auto;
          width: 400px;
        }
      }
      & .frm-login,
      & .ant-collapse {
        width: 400px;
        margin: 0 auto;
      }
    }
  }
`;

export default Styles;
